import React from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustStrip from './components/TrustStrip';
import AboutSection from './components/AboutSection';
import ProgramsSection from './components/ProgramsSection';
import FeaturesSection from './components/FeaturesSection';
import GallerySection from './components/GallerySection';
import VideoTestimonialsSection from './components/VideoTestimonialsSection';
import TestimonialsSection from './components/TestimonialsSection';
import AdmissionSection from './components/AdmissionSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <HeroSection />
      <TrustStrip />
      <AboutSection />
      <ProgramsSection />
      <FeaturesSection />
      <GallerySection />
      <VideoTestimonialsSection />
      <TestimonialsSection />
      <AdmissionSection />
      <ContactSection />
      <Footer />
      <FloatingButtons />
      <Toaster />
    </div>
  );
}

export default App;
